module.exports = __webpack_public_path__ + "static/media/game(12).a74c3bc1.PNG";